import { ClientSubscriptionProduct } from 'types/Subscription.types';
import {
  getDiscountedPriceWithSubscription,
  getOriginalPriceWithoutSubscription,
  getDiscountedPercentWithSubscription,
  Styled,
} from './';
import { useI18n } from 'contexts/i18n';

const SubscriptionPurchasePrice = ({
  subscriptionProduct,
  selectedFrequencyId,
  subscriptionQuantity,
}: {
  subscriptionProduct: ClientSubscriptionProduct | undefined;
  selectedFrequencyId: string;
  subscriptionQuantity: string | undefined;
}) => {
  const i18n = useI18n();

  return (
    <>
      <Styled.PriceContainer>
        <Styled.Price>
          {subscriptionProduct &&
            getDiscountedPriceWithSubscription(
              subscriptionProduct,
              selectedFrequencyId,
              parseInt(subscriptionQuantity || '0')
            )}
        </Styled.Price>
        <Styled.Price $shouldStrikeOff={true}>
          {subscriptionProduct &&
            getOriginalPriceWithoutSubscription(
              subscriptionProduct,
              selectedFrequencyId,
              parseInt(subscriptionQuantity || '0')
            )}
        </Styled.Price>
      </Styled.PriceContainer>
      <Styled.DiscountBox>
        {i18n['Save']}{' '}
        {subscriptionProduct &&
          getDiscountedPercentWithSubscription(
            subscriptionProduct,
            selectedFrequencyId,
            parseInt(subscriptionQuantity || '0')
          )}{' '}
      </Styled.DiscountBox>
    </>
  );
};

export default SubscriptionPurchasePrice;
